import { render, staticRenderFns } from "./BrandManage.vue?vue&type=template&id=153c6a8d&scoped=true"
import script from "./BrandManage.vue?vue&type=script&lang=js"
export * from "./BrandManage.vue?vue&type=script&lang=js"
import style0 from "./BrandManage.vue?vue&type=style&index=0&id=153c6a8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153c6a8d",
  null
  
)

export default component.exports